import { Navigate, Route, Routes } from "react-router-dom";
import React, { Suspense } from "react";
import './styles/main.scss'
import { paths } from "./utils/path";
import { useSelector } from "react-redux";


const Frontlayout = React.lazy(() =>
    import("./shared/FrontLayout/Frontlayout")
);
const LoginLayout = React.lazy(() =>
    import("./shared/FrontLayout/LoginLayout")
);

// log in imports 
const Login = React.lazy(() =>
    import("./components/Login/Login")
);
const ResetPassword = React.lazy(() =>
    import("./components/Login/ResetPassword")
);
const CheckMail = React.lazy(() =>
    import("./components/Login/CheckMail")
);
const CreateNewPassword = React.lazy(() =>
    import("./components/Login/CreateNewPassword")
);

// logged In imports 
const Dashboard = React.lazy(() =>
    import("./components/Dashboard/Dashboard")
);
const Customer = React.lazy(() =>
    import("./components/Customer/Customer")
);
const CustomerDetail = React.lazy(() =>
    import("./components/Customer/CustomerDetail")
);
const Orders = React.lazy(() =>
    import("./components/Orders/Orders")
);
const OrderDetail = React.lazy(() =>
    import("./components/Orders/OrderDetails")
);
const Banner = React.lazy(() =>
    import("./components/Banner/Banner")
);

const Brands = React.lazy(() =>
    import("./components/Products/Brands")
);
const AddNewBrand = React.lazy(() =>
    import("./components/Products/AddNewBrand")
);
const Categories = React.lazy(() =>
    import("./components/Products/Categories")
);
const AddNewCategory = React.lazy(() =>
    import("./components/Products/AddNewCategory")
);
const SubCategories = React.lazy(() =>
    import("./components/Products/SubCategories")
);
const AddNewSubCategories = React.lazy(() =>
    import("./components/Products/AddNewSubCategory")
);
const AddProducts = React.lazy(() =>
    import("./components/Products/AddProducts")
);
const AddProductVarients = React.lazy(() =>
    import("./components/Products/AddProductVarients")
);

const ProductList = React.lazy(() =>
    import("./components/Products/ProductList")
);

// notification imports
const Notification = React.lazy(() =>
    import("./components/Notification/Notification")
);

// blogs imports 
const AddBlogs = React.lazy(() =>
    import("./components/Blogs/AddBlogs")
);
const BlogList = React.lazy(() =>
    import("./components/Blogs/BlogList")
);

// faq import
const FAQ = React.lazy(() =>
    import("./components/FAQ/FAQ")
);

// coupons imports 
const Coupons = React.lazy(() =>
    import("./components/Coupons/Coupons")
);

// wallet imports 
const Wallet = React.lazy(() =>
    import("./components/Wallet/Wallet")
);

const Referrals = React.lazy(() =>
    import("./components/Referrals/Referrals")
);
const ReferralsDetails = React.lazy(() =>
    import("./components/Referrals/ReferralsDetails")
);

const SubscriptionPlan = React.lazy(() =>
    import("./components/Subscription_Plan/SubscriptionPlan")
);
const EditPlan = React.lazy(() =>
    import("./components/Subscription_Plan/EditPlan")
);

const AddCombo = React.lazy(() =>
    import("./components/Combo_Deals/AddCombo")
);
const AddNewCombo = React.lazy(() =>
    import("./components/Combo_Deals/AddNewCombo")
);
const ComboCatList = React.lazy(() =>
    import("./components/Combo_Deals/ComboProductList")
);
const AddComboCat = React.lazy(() =>
    import("./components/Combo_Deals/AddNewSubCategory")
);
const ComboProductList = React.lazy(() =>
    import("./components/Combo_Deals/ComboProductListAll")
);
const Deals = React.lazy(() =>
    import("./components/Combo_Deals/Deals")
);
const AddNewDeals = React.lazy(() =>
    import("./components/Combo_Deals/AddNewDeals")
);

// all about fitness imports 
const AllAboutFitness = React.lazy(() =>
    import("./components/AllAboutFitness/AllAboutFitness")
);

const GymGuide = React.lazy(() =>
    import("./components/Gym_Guide/GymGuide")
);

// contact us imports
const ContactUs = React.lazy(() =>
    import("./components/ContactUs/ContactUs")
);

// Offers imports 
const Offers = React.lazy(() =>
    import("./components/Offers/Offers")
);
const AddNewOffers = React.lazy(() =>
    import("./components/Offers/AddNewOffers")
);


// subscibers imports
const Subscribers = React.lazy(() =>
    import("./components/Subscribers/Subscribers")
);

// shipping imports
const ShippingDashboard = React.lazy(() =>
    import("./components/Shipping/ShippingDashboard")
);
const CreateShipment = React.lazy(() =>
    import("./components/Shipping/CreateShipment")
);
const TrackShipment = React.lazy(() =>
    import("./components/Shipping/TrackShipment")
);
const NDRManagement = React.lazy(() =>
    import("./components/Shipping/NDRManagement")
);
const ManifestManagement = React.lazy(() =>
    import("./components/Shipping/ManifestManagement")
);
const CheckServiceability = React.lazy(() =>
    import("./components/Shipping/CheckServiceability")
);

const LoaderGif = React.lazy(() =>
    import("./assets/loader.gif")
);


export default function Router() {
    const loggedIn = useSelector((state) => state?.login?.isLoggedIn);

    const loading = (
        <div className="loading">
            <img src={LoaderGif} alt="" />
        </div>
    );
    return (
        <Suspense fallback={loading}>
            <Routes>
                {!loggedIn ?
                    <Route path={paths?.front?.commonPoint} element={<LoginLayout />}>
                        <Route
                            path={paths?.front?.user?.login}
                            element={<Login />}
                        />
                        {/* <Route
                            path={paths?.front?.user?.reset_password}
                            element={<ResetPassword />}
                        />

                        <Route
                            path={paths?.front?.user?.check_mail}
                            element={<CheckMail />}
                        />

                        <Route
                            path={paths?.front?.user?.create_new_password}
                            element={<CreateNewPassword />}
                        /> */}

                        <Route path="/" element={<Navigate to="/login" />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                    </Route>

                    :
                    <Route path={paths?.front?.commonPoint} element={<Frontlayout />}>
                        <Route
                            path={paths?.front?.user?.dashboard}
                            element={<Dashboard />}
                        />

                        {/* customer path  */}
                        <Route path={paths?.front?.user?.customer} element={<Customer />}>
                        </Route>
                        <Route
                            path={`${paths?.front?.user?.customer}/:id`}
                            element={<CustomerDetail />}
                        />


                        {/* orders path  */}
                        <Route
                            path={paths?.front?.user?.orders}
                            element={<Orders />}
                        />
                        <Route
                            path={`${paths?.front?.user?.orders}/:id`}
                            element={<OrderDetail />}
                        />


                        <Route
                            path={paths?.front?.user?.banner}
                            element={<Banner />}
                        />


                        {/* product routes  */}
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.product_list}`}
                            element={<ProductList />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.brands}`}
                            element={<Brands />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.add_new_brand}`}
                            element={<AddNewBrand />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.categories}`}
                            element={<Categories />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.add_new_category}`}
                            element={<AddNewCategory />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.sub_categories}`}
                            element={<SubCategories />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.sub_categories}/${paths?.front?.user?.add_sub_categories}`}
                            element={<AddNewSubCategories />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.sub_categories}/:id`}
                            element={<AddNewSubCategories />} />
                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.add_products}`}
                            element={<AddProducts />} />

                        <Route
                            path={`${paths?.front?.user?.products}/${paths?.front?.user?.add_product_varients}`}
                            element={<AddProductVarients />} />

                        {/* notification path  */}
                        <Route
                            path={`${paths?.front?.user?.notification}`}
                            element={<Notification />} />


                        {/* blogs path  */}
                        <Route
                            path={`${paths?.front?.user?.blogs}/${paths?.front?.user?.add_blogs}`}
                            element={<AddBlogs />} />
                        <Route
                            path={`${paths?.front?.user?.blogs}/${paths?.front?.user?.blog_list}`}
                            element={<BlogList />} />

                        {/* faq path */}
                        <Route
                            path={`${paths?.front?.user?.faq}`}
                            element={<FAQ />} />

                        {/* coupons path  */}
                        <Route
                            path={`${paths?.front?.user?.coupons}`}
                            element={<Coupons />} />

                        {/* wallet path  */}
                        {/* <Route
                        path={`${paths?.front?.user?.wallet}`}
                        element={<Wallet />} /> */}

                        {/* referrals path */}
                        <Route
                            path={`${paths?.front?.user?.referrals}`}
                            element={<Referrals />} />
                        <Route
                            path={`${paths?.front?.user?.referrals}/:id`}
                            element={<ReferralsDetails />}
                        />



                        {/* subscription plan path  */}
                        <Route
                            path={`${paths?.front?.user?.subscription_plan}`}
                            element={<SubscriptionPlan />}
                        />
                        <Route
                            path={`${paths?.front?.user?.subscription_plan}/:id`}
                            element={<EditPlan />}
                        />
                        <Route
                            path={`${paths?.front?.user?.subscription_plan}/${paths?.front?.user?.add_subscription_plan}`}
                            element={<EditPlan />}
                        />

                        {/* combo/deals routes  */}
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.add_combo}`}
                            element={<AddNewCombo />} />
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.add_combo_category}`}
                            element={<AddCombo />} />
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.combo_sub_category_list}`}
                            element={<ComboCatList />} />
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.add_combo_sub_category}`}
                            element={<AddComboCat />} />

                        <Route
                            path={`${paths?.front?.user?.add_new_deal}`}
                            element={<AddNewDeals />} />
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.combo_product_list}`}
                            element={<ComboProductList />} />
                        <Route
                            path={`${paths?.front?.user?.combo}/${paths?.front?.user?.deals}`}
                            element={<Deals />} />

                        {/* all about fitness routes */}
                        <Route
                            path={`${paths?.front?.user?.all_about_fitness}`}
                            element={<AllAboutFitness />} />

                        {/* gym guide  */}
                        <Route
                            path={`${paths?.front?.user?.gym_guide}`}
                            element={<GymGuide />} />

                        {/* contact us routes */}
                        <Route
                            path={`${paths?.front?.user?.contact_us}`}
                            element={<ContactUs />} />

                        {/* offers routes */}
                        <Route
                            path={`${paths?.front?.user?.offers}`}
                            element={<Offers />} />
                        <Route
                            path={`${paths?.front?.user?.add_new_offer}`}
                            element={<AddNewOffers />} />

                        {/* subscribers routes */}
                        <Route
                            path={`${paths?.front?.user?.subscribers}`}
                            element={<Subscribers />} />

                        {/* shipping routes */}
                        <Route
                            path={`${paths?.front?.user?.shipping}`}
                            element={<ShippingDashboard />} />
                        <Route
                            path={`${paths?.front?.user?.shipping_create}`}
                            element={<CreateShipment />} />
                        <Route
                            path={`${paths?.front?.user?.shipping_track}`}
                            element={<TrackShipment />} />
                        <Route
                            path={`${paths?.front?.user?.shipping_ndr}`}
                            element={<NDRManagement />} />
                        <Route
                            path={`${paths?.front?.user?.shipping_manifest}`}
                            element={<ManifestManagement />} />
                        <Route
                            path={`${paths?.front?.user?.shipping_serviceability}`}
                            element={<CheckServiceability />} />


                        <Route path="/" element={<Navigate to="/dashboard" />} />
                        <Route path="*" element={<Navigate to="/dashboard" />} />
                    </Route>
                }


            </Routes>
        </Suspense>
    );
}
